import { Link } from "react-router-dom";
import { ArrowRight, BadgeCheck, ShieldCheck, UserCheck } from "lucide-react";
import { Crumbs } from "../product/ProductHero";

export const PortfolioHero = ({ crumbs, eyebrow, title, lead, children, aside, testid = "portfolio-hero" }) => (
  <section aria-labelledby="portfolio-title" className="relative overflow-hidden border-b border-slate-200 bg-white" data-testid={testid}>
    <div className="hero-grid absolute inset-y-0 right-0 hidden w-[55%] lg:block" aria-hidden="true" />
    <div className="container-tight relative grid items-center gap-10 pb-12 pt-6 sm:pt-8 lg:grid-cols-12 lg:gap-12 lg:pb-16">
      <div className="reveal lg:col-span-7">
        <Crumbs items={crumbs} />
        <p className="eyebrow mt-6">{eyebrow}</p>
        <h1 id="portfolio-title" className="h1 mt-3 text-balance lg:text-[2.6rem] xl:text-[3rem]" data-testid="portfolio-title">{title}</h1>
        <p className="lead mt-4 max-w-2xl" data-testid="portfolio-lead">{lead}</p>
        {children}
      </div>
      {aside && <div className="reveal lg:col-span-5 [animation-delay:120ms]">{aside}</div>}
    </div>
  </section>
);

const POLICY = [
  [BadgeCheck, "Alleen eigen werk", "Uitsluitend projecten die Maas Kozijn zelf heeft uitgevoerd."],
  [ShieldCheck, "Eerst gecontroleerd", "Foto's, plaats en werkzaamheden worden vóór publicatie gecontroleerd."],
  [UserCheck, "Met toestemming", "Klantreacties alleen met uitdrukkelijke toestemming van de klant."],
];

// Compacte publicatiebelofte: drie korte punten op één regel.
export const PublishPolicy = () => (
  <ul className="mt-6 flex flex-wrap gap-x-5 gap-y-2 text-[13.5px] text-slate-600" aria-label="Zo publiceren wij projecten" data-testid="publish-policy">
    {POLICY.map(([Icon, t, d]) => (
      <li key={t} className="inline-flex items-center gap-1.5" title={d}><Icon className="h-4 w-4 text-maas" aria-hidden="true" /><span className="font-semibold text-ink">{t}</span></li>
    ))}
  </ul>
);

// Beeldmozaïek voor de hero; labels alleen bij inspiratiebeelden.
export const ImageMosaic = ({ items, badge, testid = "hero-mosaic" }) => (
  <ul className="grid grid-cols-2 gap-3" aria-hidden="true" data-testid={testid}>
    {items.slice(0, 4).map((it, i) => (
      <li key={it.id} className={`relative overflow-hidden rounded-2xl bg-slate-100 ${i % 2 ? "translate-y-5" : ""}`}>
        <img src={it.src} srcSet={it.srcSet} sizes="260px" alt="" className="aspect-[4/5] w-full object-cover" loading={i < 2 ? "eager" : "lazy"} />
        {badge && <span className="absolute left-2 top-2 rounded-md bg-white/90 px-1.5 py-0.5 text-[10.5px] font-medium text-slate-700">{badge(it)}</span>}
      </li>
    ))}
  </ul>
);

export const CrossLink = ({ to, text, label, testid, className = "section-tight pt-0" }) => (
  <section aria-label={label} className={className} data-testid={testid}>
    <div className="container-tight">
      <Link to={to} className="group flex flex-col gap-2 rounded-2xl border border-slate-200 bg-slate-50 px-5 py-5 transition-colors hover:border-maas/40 hover:bg-maas-soft/60 sm:flex-row sm:items-center sm:justify-between sm:px-7">
        <span className="text-[15.5px] text-ink">{text}</span>
        <span className="inline-flex items-center gap-1.5 text-[15px] font-semibold text-maas">{label} <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" aria-hidden="true" /></span>
      </Link>
    </div>
  </section>
);
